<template>
  <el-dialog
    title="申请退款审核"
    :visible.sync="dialogVisible"
    width="600px"
    class="dialog"
  >
    <el-form :model="form" label-width="100px">
      <el-form-item label="委托单号">
        {{ order.checkmallOrderMainId }}
      </el-form-item>
      <el-form-item label="仪器名称">
        {{ order.checkmallWaresName }}
      </el-form-item>
      <el-form-item label="退款金额"> ￥{{ order.orderPrice }} </el-form-item>
      <el-form-item label="申请退款原因">
        {{ order.refundReason }}
      </el-form-item>
      <el-form-item label="商家审核结果" class="dialog-result">
        <el-radio-group v-model="form.saleStatus">
          <el-radio :label="REFUND_STATUS_MAP.mallPass">审核通过</el-radio>
          <el-radio :label="REFUND_STATUS_MAP.mallFailed">审核驳回</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="审核备注">
        <el-input
          type="textarea"
          :rows="4"
          placeholder="请输入内容"
          v-model="form.rejectReason"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="confirmClick" :loading="btnLoading"
        >提 交</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { applyRefund } from "@/api/userCenter";
import { REFUND_STATUS_MAP, REFUND_STATUS_TEXT } from "@/constant/dict";
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {},
      REFUND_STATUS_MAP,
      REFUND_STATUS_TEXT,
      btnLoading: false,
    };
  },
  computed: {
    dialogVisible: {
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    async confirmClick() {
      const { checkmallOrderMainId } = this.order;
      const params = {
        checkmallOrderMainId,
        ...this.form,
      };
      this.btnLoading = true;
      await this.$axios.put(applyRefund, params).finally(() => {
        this.btnLoading = false;
      });
      if (this.form.saleStatus == REFUND_STATUS_MAP.mallPass) {
        this.$message.success("提交成功,等待平台审核");
      } else {
        this.$message.success("提交成功");
      }
      this.$emit("refresh");
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog {
  ::v-deep .el-form-item {
    margin-bottom: 0px;
  }
  &-result {
    margin-bottom: 10px !important;
  }
  ::v-deep .el-dialog__body {
    padding: 0 20px 10px 20px;
  }
}
</style>
